import React from 'react';

export type Props = {
    size: string;
};

export const RelayIcon = ({ size }: Props) =>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 426.5 260.6"
        className={ `device-class-icon ${size}` }
    >
        <path
            fill="#d7d7d7"
            stroke="#000000"
            strokeWidth="8"
            d="m414.07 4c4.65 0 8.42 3.77 8.42 8.43v235.72c0 4.65-3.77 8.42-8.42 8.42h-401.65c-4.65 0-8.42-3.77-8.42-8.42v-235.72c0-4.66 3.77-8.43 8.42-8.43h401.65z"
        />
        <path
            fill="#7a7a7a"
            d="m8 129.45h100.7v33.88h-100.7v-33.88z"
        />
        <path
            fill="#d7d7d7"
            stroke="#7a7a7a"
            strokeWidth="30"
            d="m175.07 146.39c0 20.7-16.8 37.5-37.5 37.5-20.69 0-37.5-16.8-37.5-37.5s16.81-37.5 37.5-37.5c20.7 0 37.5 16.8 37.5 37.5z"
        />
        <path
            fill="#7a7a7a"
            d="m419.2 129.45h-100.71v33.88h100.71v-33.88z"
        />
        <path
            fill="#d7d7d7"
            stroke="#7a7a7a"
            strokeWidth="30"
            d="m256.15 146.39c0 20.7 16.81 37.5 37.5 37.5 20.7 0 37.5-16.8 37.5-37.5s-16.8-37.5-37.5-37.5c-20.69 0-37.5 16.8-37.5 37.5z"
        />
        <path
            fill="#7a7a7a"
            d="m117.88 97.82l182.96-66.59 10.04 27.58-182.96 66.59-10.04-27.58z"
        />
    </svg>;
